import { useEffect } from "react";

import { usePermanentLocations, usePermanentRealtimeDealers } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient, useTypedQuery } from "hooks";
import { USER_STATUSES } from "modules/UsersDashboard/hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { USERS_DASHBOARD_STORAGE_KEYS } from "modules/UsersDashboard/storageKeys";
import { PAGE_SIZE, getPreference } from "utils/common";

import type { UsersDashboardFilter } from "modules/UsersDashboard/queryKeys";

const getDefaultUsersDashboardFilters = (): UsersDashboardFilter => ({
  active_date_from: getPreference(USERS_DASHBOARD_STORAGE_KEYS.ActiveDateFromPreference, null),
  active_date_to: getPreference(USERS_DASHBOARD_STORAGE_KEYS.ActiveDateToPreference, null),
  is_combi_user: getPreference(USERS_DASHBOARD_STORAGE_KEYS.CombiUserPreference, null),
  dealer_location_ids: [],
  is_dpo: getPreference(USERS_DASHBOARD_STORAGE_KEYS.DPOPreference, null),
  mobile_versions: getPreference(USERS_DASHBOARD_STORAGE_KEYS.MobileVersionsPreference, null),
  roles: getPreference(USERS_DASHBOARD_STORAGE_KEYS.RolesPreference, []),
  status: getPreference(USERS_DASHBOARD_STORAGE_KEYS.StatusPreference, USER_STATUSES.Active),
  web_versions: getPreference(USERS_DASHBOARD_STORAGE_KEYS.WebVersionPreference, null),
  term: "",
  page: 1,
  page_size: getPreference(USERS_DASHBOARD_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25),
  dealer_ids: []
});

export const useGetUsersDashboardFilters = () => {
  const { dealers } = usePermanentRealtimeDealers();
  const { locations } = usePermanentLocations();

  const dealerIds = dealers.map(({ id }) => id);
  const locationIds = locations.filter(loc => loc.active).map(({ id }) => id);

  useEffect(() => {
    if (!dealers.length && !locations.length) return;

    typedQueryClient.setQueryData(UsersDashboardQueryKeys.filters, { ...getDefaultUsersDashboardFilters(), dealer_location_ids: locationIds });
  }, [dealerIds.length, locationIds.length]);

  const { data: filters, isLoading } = useTypedQuery({ queryKey: UsersDashboardQueryKeys.filters, initialData: getDefaultUsersDashboardFilters() });
  return { filters, isLoading };
};

export const setUsersDashboardFilters = (newFilters: UsersDashboardFilter) => {
  const filters = typedQueryClient.getQueryData(UsersDashboardQueryKeys.filters);
  if (!filters) return;
  typedQueryClient.setQueryData(UsersDashboardQueryKeys.filters, { ...filters, ...newFilters });
};
